import { render, staticRenderFns } from "./DriverPage.vue?vue&type=template&id=66af2b00&scoped=true&"
import script from "./DriverPage.vue?vue&type=script&lang=js&"
export * from "./DriverPage.vue?vue&type=script&lang=js&"
import style0 from "./DriverPage.vue?vue&type=style&index=0&id=66af2b00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66af2b00",
  null
  
)

export default component.exports